import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    project: 'irene',
    demo: false,
    code: false,
    authentication: false,
    globalPreloader: false,

    localPreloader: false,
    // api: {
    //   url: 'https://api-demo.call-me.info/api/',
    //   avatarsUrl: 'https://api-demo.call-me.info/api/uploads/avatars/',
    //   articlesUrl: 'https://api-demo.call-me.info/api/uploads/articles/',
    //   slidesUrl: 'https://api-demo.call-me.info/api/uploads/slides/',
    //   galleryUrl: 'https://api-demo.call-me.info/api/uploads/gallery/',
    //   teamUrl: 'https://api-demo.call-me.info/api/uploads/team/',
    //   logoUrl: 'https://api-demo.call-me.info/api/uploads/logo/',
    //   bgUrl: 'https://api-demo.call-me.info/api/uploads/bg/',
    //   menuCategoriesUrl: 'https://api-demo.call-me.info/api/uploads/menuCategories/',
    //   menuDishesUrl: 'https://api-demo.call-me.info/api/uploads/menuDishes/',
    //   productsUrl: 'https://api-demo.call-me.info/api/uploads/products/',
    //   bannersUrl: 'https://api-demo.call-me.info/api/uploads/banners/',
    //   qrUrl: 'https://api-demo.call-me.info/'
    // },
    api: {
      url: 'https://api.irene.kz/api/',
      avatarsUrl: 'https://api.irene.kz/api/uploads/avatars/',
      articlesUrl: 'https://api.irene.kz/api/uploads/articles/',
      slidesUrl: 'https://api.irene.kz/api/uploads/slides/',
      galleryUrl: 'https://api.irene.kz/api/uploads/gallery/',
      teamUrl: 'https://api.irene.kz/api/uploads/team/',
      logoUrl: 'https://api.irene.kz/api/uploads/logo/',
      bgUrl: 'https://api.irene.kz/api/uploads/bg/',
      menuCategoriesUrl: 'https://api.irene.kz/api/uploads/menuCategories/',
      menuDishesUrl: 'https://api.irene.kz/api/uploads/menuDishes/',
      productsUrl: 'https://api.irene.kz/api/uploads/products/',
      bannersUrl: 'https://api.irene.kz/api/uploads/banners/',
      qrUrl: 'https://api.irene.kz/'
    },
    accountInfo: {
      countryId: 1,
      cityId: 1,
      profile: [],
      otherAuth: false
    },
    reservClient: {
      id: 0,
      client: null
    },
    initPageInfo: {
      /* Раскоментить для IRENE */
      partner_id: 1,
      catalog_link: '',
      catalog_name: 'Irene',
      catalogType: 'company',
      catalogLp: 'custom',
      catalogSet: 'full',
      catalog_category: 1
    },
    pageInfo: {
      slides: [],
      gallery: [],
      contacts: [],
      team: [],
      table: []
    },
    uniqKeyBookingPull: [],
    viewMode: 0,
    scrollPosition: 0,
    /* СТОЛИКИ */
    tables: [],
    tableReservations: [],
    menuUserSelect: [],
    countries: [],
    selectedCityId: 0,
    selectedCityName: 'Город',
    globalSignModal: false,
    authType: 'login',
    globalCityModal: false,
    globalPartnerModal: false,
    globalCatalog: [],
    globalFav: []
  },
  mutations: {
    authentication (state, status) {
      state.authentication = status
    },
    profile (state, data) {
      state.accountInfo.profile = data
    },
    initPageInfo (state, data) {
      state.initPageInfo = data
    },
    pageInfo (state, data) {
      state.pageInfo = data
    },
    globalPreloader (state, status) {
      state.globalPreloader = status
    },
    pushUniqKeyBooking (state, data) {
      state.uniqKeyBookingPull = data
    },
    otherAuth (state, data) {
      state.accountInfo.otherAuth = data
    },
    reservClient (state, data) {
      state.reservClient = data
    },
    viewMode (state, data) {
      state.viewMode = data
    },
    scrollPosition (state, data) {
      state.scrollPosition = data
    },
    tables (state, data) {
      state.tables = data
    },
    reservTable (state, data) { // Обновление статуса столика
      if (state.tables.length !== 0) {
        if (state.tables[data.table_id] !== undefined) {
	        state.tables[data.table_id].status = data.status
	        state.tables[data.table_id].client_id = data.client_id
	        state.tables[data.table_id].reserv_id = data.reserv_id
        }
      }
    },
    tableReservations (state, data) { // Получение всех бронирований столика
      state.tableReservations = data
    },
	  menuUserSelect (state, data) {
      console.log(data.id)
      // state.menuUserSelect = data
		  Vue.set(state.menuUserSelect, data.id, data.dish)
		  // state.menuUserSelect[data.id] = data.dish
      console.log(state.menuUserSelect)
    },
	  menuUserSelectDelete (state, data) {
		  Vue.set(state.menuUserSelect, data, {count: 0})
	  },
    bindingTable (state, data) {
	    state.tables[data.table_id].status = data.status
    },
    countriesSite (state, data) {
      state.countries = data
    },
    selectedCity (state, data) {
      state.selectedCityId = data.cityId
      state.selectedCityName = data.cityName
      localStorage.setItem('selectedCityId', data.cityId)
      localStorage.setItem('selectedCityName', data.cityName)
    },
    toggleSignModal (state, data) {
      state.globalSignModal = data
    },
    authType (state, data) {
      state.authType = data
    },
    toggleCityModal (state, data) {
      state.globalCityModal = data
    },
    togglePartnerModal (state, data) {
      state.globalPartnerModal = data
    },
    globalCatalog (state, data) {
      state.globalCatalog = data
    },
    globalCatalogFav (state, data) {
      state.globalCatalog[data.partner_id].client_id = data.type
    },
    globalFav (state, data) {
      state.globalFav = data
    },
    globalFavFav (state, data) {
      state.globalFav[data.partner_id].client_id = data.type
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js